module.exports = __webpack_public_path__ + "img/malna-pink.17a02fef.webp";